module.exports = require('./lib/ReactWithAddons');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/addons.js
 ** module id = 222
 ** module chunks = 0
 **/